<template>
    <validation-observer v-slot="{ handleSubmit }" ref="formHandler">
        <form class="form" @submit.prevent="handleSubmit(formSubmit)" novalidate>
            <div class="form-title tw-text-center tw-flex tw-flex-col tw-items-center tw-justify-center tw-font-extrabold tw-text-white tw-leading-none">
                SAIBA QUAL A SOLUÇÃO DE SEGURO* MAIS ADEQUADA PARA SI
            </div>
            <fieldset class="tw-px-3 tw-pb-3 tw-pt-5 lg:tw-px-10 lg:tw-pb-12">
                <div class="step" v-if="step === 1">
                    <validation-provider class="tw-w-full tw-w-block" name="fullName" rules="required|alpha_spaces" v-slot="{ classes }">
                        <div class="input-group input-group-name" :class="classes">
                            <input type="text"
                                id="input-fullName"
                                placeholder=" "
                                v-model="fullName"
                            >
                            <label>
                                Nome e Apelido
                            </label>
                        </div>
                    </validation-provider>
                    <validation-provider class="tw-w-full tw-w-block" name="email" rules="required|email" v-slot="{ classes, errors }" :custom-messages="{ required: ' ', email: 'inválido' }">
                        <div class="input-group input-group-email" :class="classes">
                            <input type="email"
                                id="input-email"
                                placeholder=" "
                                v-model.lazy="email"
                            >
                            <label>
                                Email {{ errors [0]}}
                            </label>
                        </div>
                    </validation-provider>
                    <div class="tw-flex tw-flex-col lg:tw-flex-row lg:tw-gap-3">
                        <validation-provider class="tw-w-full tw-w-block" name="phone" rules="required|phone:pt" v-slot="{ classes }">
                            <div class="input-group input-group-phone" :class="classes">
                                <input type="tel"
                                    id="input-phone"
                                    placeholder=" "
                                    v-model="phone"
                                    v-mask="{mask: '999999999', placeholder: ' '}"
                                >
                                <label>
                                    Nº Telemóvel
                                </label>
                            </div>
                        </validation-provider>
                        <validation-provider class="tw-w-full tw-w-block" name="nif" rules="required|nif" v-slot="{ classes }">
                            <div class="input-group input-group-nif" :class="classes">
                                <input type="tel"
                                    id="input-nif"
                                    placeholder=" "
                                    v-model="nif"
                                    v-mask="{mask: '999999999', placeholder: ' '}"
                                >
                                <label>
                                    NIF
                                </label>
                            </div>
                        </validation-provider>
                    </div>
                    <div class="legals">
                        <h4>Por que precisamos dos seus dados?</h4>
                        <p class="legals">Os dados pessoais por si acima facultados serão tratados <strong>para posterior contacto telefónico com a finalidade de realizar a simulação</strong> e para fazer o acompanhamento comercial da mesma, com fundamento no desenvolvimento de diligências pré-contratuais a pedido do titular e no interesse legítimo do desenvolvimento da atividade comercial da Fidelidade.</p>
                        <a href="https://www.fidelidade.pt/PT/protecao-dados/Documents/Politica_de_Privacidade_e_Protecao_de_Dados_Pessoais%E2%80%93FIDELIDADE.pdf" target="_blank"><legend>Consulte aqui, informação mais detalhada sobre proteção e tratamento dos seus dados pela Fidelidade.</legend></a>
                    </div>
                    <div class="tw-text-center tw-mt-4">
                        <button class="btn-cta" :disabled="formLoading" :class="{ 'disabled' : !phone || !fullName || !email || !nif }" @click.prevent="nextStep();">PEDIR CONTACTO <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14.828" viewBox="0 0 14 14.828"><g transform="translate(-6.5 -6.086)"><path d="M7.5,18h12" transform="translate(0 -4.5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path><path d="M18,7.5l6,6-6,6" transform="translate(-4.5 0)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path></g></svg></button>
                    </div>
                </div>
                <div class="step" v-if="step === 2">
                    <p class="question tw-pb-2">Data de nascimento</p>
                        <div class="dob tw-flex tw-gap-3">
                            <validation-provider rules="required" class="select-area tw-relative" v-slot="{ classes }">
                                <select v-model="birthDay" :class="classes" class="dob-select tw-relative" @change="updateDate">
                                    <option disabled selected value="">Dia</option>
                                    <option value="01">1</option>
                                    <option value="02">2</option>
                                    <option value="03">3</option>
                                    <option value="04">4</option>
                                    <option value="05">5</option>
                                    <option value="06">6</option>
                                    <option value="07">7</option>
                                    <option value="08">8</option>
                                    <option value="09">9</option>
                                    <option value="10">10</option>
                                    <option value="11">11</option>
                                    <option value="12">12</option>
                                    <option value="13">13</option>
                                    <option value="14">14</option>
                                    <option value="15">15</option>
                                    <option value="16">16</option>
                                    <option value="17">17</option>
                                    <option value="18">18</option>
                                    <option value="19">19</option>
                                    <option value="20">20</option>
                                    <option value="21">21</option>
                                    <option value="22">22</option>
                                    <option value="23">23</option>
                                    <option value="24">24</option>
                                    <option value="25">25</option>
                                    <option value="26">26</option>
                                    <option value="27">27</option>
                                    <option value="28">28</option>
                                    <option value="29">29</option>
                                    <option value="30">30</option>
                                    <option value="31">31</option>
                                </select>
                                <label v-if="!birthDay">
                                    Dia
                                </label>
                            </validation-provider>
                            <validation-provider rules="required" class="select-area tw-relative" v-slot="{ classes }">
                                <select v-model="birthMonth" :class="classes" class="dob-select tw-relative" @change="updateDate">
                                    <option disabled selected value="">Mês</option>
                                    <option value="01">Jan</option>
                                    <option value="02">Fev</option>
                                    <option value="03">Mar</option>
                                    <option value="04">Abr</option>
                                    <option value="05">Mai</option>
                                    <option value="06">Jun</option>
                                    <option value="07">Jul</option>
                                    <option value="08">Ago</option>
                                    <option value="09">Set</option>
                                    <option value="10">Out</option>
                                    <option value="11">Nov</option>
                                    <option value="12">Dez</option>
                                </select>
                                <label v-if="!birthMonth">
                                    Mês
                                </label>
                            </validation-provider>
                            <validation-provider class="select-area tw-relative" rules="required" v-slot="{ classes }">
                                <select v-model="birthYear" :class="classes" class="dob-select tw-relative input-year" @change="updateDate()">
                                    <!-- <option disabled selected value="">Ano</option> -->
                                </select>
                                <label v-if="!birthYear">
                                    Ano
                                </label>
                            </validation-provider>
                        </div>
                    <p class="question tw-pb-2">Código Postal</p>
                    <validation-provider class="tw-w-full tw-w-block" name="zip" rules="required|zip:pt" v-slot="{ classes }" :key="'inputzip'">
                        <div class="input-group input-group-zip" :class="classes">
                            <input type="tel"
                                id="input-phone"
                                placeholder=" "
                                v-model="zip"
                                v-mask="{mask: '9999-999', placeholder: ' '}"
                            >
                            <label>
                                Código Postal
                            </label>
                        </div>
                    </validation-provider>
                    <div class="tw-flex tw-flex-row tw-w-full tw-gap-3">
                        <button class="btn-back" @click.prevent="step = 1;">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14.828" viewBox="0 0 14 14.828"><g transform="translate(-6.5 -6.086)"><path d="M7.5,18h12" transform="translate(0 -4.5)" fill="#d71f26" stroke="#d71f26" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path><path d="M18,7.5l6,6-6,6" transform="translate(-4.5 0)" fill="none" stroke="#d71f26" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path></g></svg>
                        </button>
                        <button type="submit" class="btn-cta tw-w-full tw-flex tw-items-center tw-gap-5 tw-justify-center" id="submit" :disabled="formLoading">
                            PEDIR CONTACTO
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14.828" viewBox="0 0 14 14.828">
                                <g id="Icon_feather-arrow-right" data-name="Icon feather-arrow-right" transform="translate(-6.5 -6.086)">
                                <path id="Path_507" data-name="Path 507" d="M7.5,18h12" transform="translate(0 -4.5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                                <path id="Path_508" data-name="Path 508" d="M18,7.5l6,6-6,6" transform="translate(-4.5 0)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                                </g>
                            </svg>
                        </button>
                    </div>
                </div>
                <div class="bullets tw-flex tw-items-center tw-justify-center tw-gap-2 tw-pt-6">
                    <div :class="{ 'active' : step >= 1 }"></div>
                    <div :class="{ 'active' : step === 2 }"></div>
                </div>
            </fieldset>
        </form>
    </validation-observer>
</template>

<script>
import axios from 'axios';
// Check validations folder for more validations
import '@/validations';
import '@/validations/phone';
import '@/validations/nif';
import '@/validations/zip';

export default {
    name: 'FormComponent',
    data() {
        return {
            fullName: '',
            phone: '',
            email: '',
            nif: '',
            zip: '',
            page: 'B',

            birthDay: null,
            birthMonth: null,
            birthYear: null,
            birthdate: undefined,

            step: 1,
            formLoading: false,
            usedClasses: ['.has-error'],
            company: process.env.VUE_APP_COMPANY,
        };
    },
    mounted() {
        if(this.$route.path == '/b') {
            this.page = 'B'
        }
    },
    methods: {
        nextStep() {
            if ((document.querySelector('.input-group-name').classList.contains('has-error')) || (document.querySelector('.input-group-phone').classList.contains('has-error')) || (document.querySelector('.input-group-email').classList.contains('has-error')) || (document.querySelector('.input-group-nif').classList.contains('has-error'))) {
                return false;
            }
            this.step++;
            setTimeout(() => {
                var year = 0,
                currentYear = new Date().getFullYear(),
                previousHundredYears = currentYear - 100,
                nextEighteenYears = currentYear - 18;
                var emptyOption = document.createElement("option");
                emptyOption.text = 'Ano';
                emptyOption.value = '';
                document.querySelector('.input-year').appendChild(emptyOption);
                for (year = previousHundredYears; year <= nextEighteenYears; year++) {
                    const option = document.createElement("option");
                    option.value = year;
                    option.text = year;
                    document.querySelector('.input-year').appendChild(option);
                    this.birthYear = null;
                }
                emptyOption.setAttribute('disabled', true);
                document.querySelector('.input-group-zip').classList.remove('has-error');
            }, 100);
        },
        updateDate() {
            this.birthdate = this.birthYear + '-' + this.birthMonth + '-' + this.birthDay;
        },
        formSubmit() {
            this.formLoading = true;
            this.$store.state.formName = this.fullName;

            const action = `${process.env.VUE_APP_BACKOFFICE_ENDPOINT}/api/${process.env.VUE_APP_BACKOFFICE_SLUG}`;
            const data = {
                pubid: this.$route.query.pubid,
                utm_source: this.$route.query.utm_source,
                utm_campaign: this.$route.query.utm_campaign,
                utm_medium: this.$route.query.utm_medium,
                utm_content: this.$route.query.utm_content,
                utm_term: this.$route.query.utm_term,
                token: this.$store.state.token,

                fullName: this.fullName,
                phone: this.phone,
                email: this.email,
                zip: this.zip,
                nif: this.nif,
                birthdate: this.birthdate,
                page: this.page,
            };

            axios.post(action, data)
                .then((response) => {
                    this.$store.state.formSuccess = true;
                    this.$store.state.argann = response.data.argann;
                    this.$store.state.altid = response.data.altid;
                    gtag('event', 'conversion', { 'send_to': 'AW-389361952/OxHZCNW_5LwDEKDi1LkB' });
                })
                .catch((error) => {
                    this.formLoading = false;
                    if (error.response.status == '302') {
                        this.$store.state.formError = true;
                    }
                    if (error.response.data.errors.email) {
                        error.response.data.errors.email = 'já registado';
                        this.step = 1;
                    }
                    console.log(error.response.data.errors);
                    this.$refs.formHandler.setErrors(error.response.data.errors);
                });
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/partials/_variables.scss';
@import '~@/assets/scss/partials/_fonts.scss';

.form {
    box-shadow: 2px 2px 12px 0 rgba(0,0,0,.1);

    @screen lg {
        box-shadow: none;
    }

    .form-title {
        @apply tw-relative tw-pt-10 tw-pb-3 tw-px-4;
        background-color: $main_color;
        border-top-left-radius: 0px;
        border-top-right-radius: 0px;
        font-size: 22px;

        @screen lg {
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
        }

        &::before {
            @apply tw-absolute tw-bg-no-repeat tw-bg-center tw-rounded-full;
            background-size: 60%;
            background-color: $main_color;
            background-image: url('~@/assets/img/icons/car.svg');
            content: '';
            width: 85px;
            height: 85px;
            top: -42.5px;
        }
    }

    fieldset {

        .step {

            .legals {

                h4 {
                    @apply tw-font-bold;
                    font-weight: 700;
                    font-size: 11px;
                    line-height: 14px;
                    color: $black;
                }

                p {
                    font-size: 11px;
                    line-height: 14px;

                    b, strong {
                        font-weight: 700;
                        color: $black;
                    }
                }

                a {
                    @apply tw-underline;
                    font-size: 10px;
                    line-height: 14px;
                    color: $whine;
                }
            }

            .question {
                @apply tw-text-sm;
                color: $dark;
                font-weight: 900;
            }

            .select-area {
                width: 100%;
                @apply tw-flex tw-items-center tw-justify-center tw-gap-10 tw-px-0;

                label {
                    position: absolute;
                    z-index: 2;
                    left: 50%;
                    transform: translateX(-50%);
                    top: 17.5%;
                    pointer-events: none;
                    font-weight: 700;
                    color: $dark;
                }

                .dob-select {
                    border: solid 2px $border;
                    background-color: $grey;
                    border-radius: 4px;
                    padding: 3.5px 7.5px;
                    margin-bottom: 25px;
                    min-width: 101.5px;
                    height: 50px;
                    outline: none;
                    appearance: none;
                    position: relative;
                    background-image: url('~@/assets/img/icons/select.svg');
                    background-position-x: 94%;
                    background-position-y: 50%;
                    background-size: 12.5px;
                    background-repeat: no-repeat;
                    text-align: center;
                    color: $dark;
                    font-weight: 700;

                    @screen lg {
                        background-position-x: 87.5%;
                        background-size: 12.5px;
                        min-width: none;
                        max-width: none;
                        width: 115px;
                    }

                    &:focus {
                        border-color: $leaf-green;
                    }
                }

                &::before {
                    content: '';
                    position: absolute;
                    left: 12.5px;
                    top: 23.5%;
                    width: 16px;
                    height: 15.03px;
                    background-image: url('~@/assets/img/icons/calendar.svg');
                    background-position: center;
                    background-repeat: no-repeat;
                    background-size: cover;
                    z-index: 2;

                    @screen lg {
                        left: 20px;
                    }
                }
            }
        }

        .bullets {
            >div {
                @apply tw-bg-white tw-rounded-full tw-w-3 tw-h-3;
                border: solid 2px $border;

                &.active {
                    background-color: $border;
                }
            }
        }
    }
}
</style>
